define('SageDotCom/Components/Videos/DigitalNewsroomVideo',[
    "jquery",
    "eventManager",
    "SageDotCom/Components/Videos/YoutubeVideo"
],
    function ($, eventManager, Youtube) {
        function DigitalNewsroomVideo(scope, stateChange, playMessage, pauseMessage, className, playInModal) {
            // Function to be called when the .youtube-video-section elements become visible
            function initializeTracking(videoScope) {
                const videoFrame = $("lite-youtube", videoScope);
                if (!videoFrame.attr("id").includes(className)) {
                    // Append class names to the videoFrame id
                    videoFrame.attr({ id: videoFrame.attr("id") + "-" + className });

                    const args = {};
                    args.scope = videoScope;
                    args.stateChange = stateChange;
                    args.playMessage = playMessage;
                    args.pauseMessage = pauseMessage;
                    args.playInModal = playInModal;
                    args.guid = $(videoScope).attr("data-guid");

                    Youtube.init(args);

                    //Handle modal showing as first click fallback
                    setTimeout(function () {
                            const $modalVideo = $(".modal", videoScope);
                            videoScope.parents(".video-card").addClass("disable-hover");
                            $modalVideo.modal("show");
                        },
                        250);
                }
            }

            eventManager.subscribe("digital-newsroom-find-dupes",
                function() {
                    var videoIds = {};

                    $(".digital-newsroom-landing-page").find(".digital-newsroom-listings lite-youtube").each(
                        function(index, element) {
                            const videoId = $(element).prop("id");

                            if (videoIds[videoId]) {
                                const newVideoId = videoId + "_" + index;
                                $(element).prop("id", newVideoId);
                            }

                            videoIds[videoId] = true;
                        });
                });

            //Happens if, e.g. filter changes
            var observeTimeout = undefined;
            eventManager.subscribe("digital-newsroom-observe-videos",
                function() {
                    clearTimeout(observeTimeout);
                    observeTimeout = setTimeout(function() {
                            //List of videos on the page
                            const $youtubeVideo = $(".youtube-video-section", scope);

                            $youtubeVideo.each(function() {
                                const currentElement = $(this)[0];
                                const targetNode = currentElement;

                                // Options for the observer (include the subtree so it observes all descendants)
                                const observerConfig = { childList: true, subtree: true };

                                // Callback function to execute when mutations are observed
                                const callback = function(mutationsList, observer) {
                                    for (const mutation of mutationsList) {
                                        if (mutation.type === "childList") {
                                            // Check if the added nodes are iframes
                                            const addedNodes = mutation.addedNodes;
                                            for (const node of addedNodes) {
                                                if (node.tagName === "IFRAME") {
                                                    // Find the parent element with class 'youtube-video-section'
                                                    const parentComponent = $(node).closest(".youtube-video-section");

                                                    // If an iframe is added, initialize tracking
                                                    initializeTracking(parentComponent);

                                                    // Disconnect the observer as it's no longer needed
                                                    observer.disconnect();

                                                    //Continue observing the next video
                                                    return;
                                                }
                                            }
                                        }
                                    }
                                };

                                const observer = new MutationObserver(callback);
                                observer.observe(targetNode, observerConfig);
                            });


                            $(scope).on("keypress",
                                function(event) {
                                    if (event.keyCode === 13) {
                                        const youtubeSection =
                                            $(event.target).find(".youtube-video-button, lite-youtube");
                                        youtubeSection.click();
                                    }
                                });
                        },
                        500);
                });
        }

        return function initVideoListing(args) {
            return args.IsExperienceEditorEditing
                ? null
                : new DigitalNewsroomVideo(args.scope,
                    args.stateChange || [],
                    args.playMessage || [],
                    args.pauseMessage || [],
                    args.className || "",
                    args.playInModal);
        };
    });

